import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../components';
import './NotFound.css';

const NotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <>
            <Header />
            <div className="not-found-container">
                <div className="not-found-content">
                    {/* 404 Icon */}
                    <div className="not-found-icon">
                        <div className="not-found-number">404</div>
                    </div>

                    {/* Error Message */}
                    <h1 className="not-found-title">
                        {t('notFound.title')}
                    </h1>
                    <p className="not-found-subtitle">
                        {t('notFound.subtitle')}
                    </p>
                    <p className="not-found-description">
                        {t('notFound.description')}
                    </p>

                    {/* Action Buttons */}
                    <div className="not-found-actions">
                        <button
                            onClick={handleGoHome}
                            className="not-found-btn-primary"
                        >
                            {t('notFound.goHome')}
                        </button>
                        
                        <button
                            onClick={handleGoBack}
                            className="not-found-btn-secondary"
                        >
                            {t('notFound.goBack')}
                        </button>
                    </div>

                    {/* Additional Help */}
                    <div className="not-found-help">
                        <p className="not-found-help-text">
                            {t('notFound.helpText')}
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default NotFound;
